<template>
    <b-row>
        <div class="col-lg-12 col-md-12 mt-2">
            <container-card id="filtroDRE" icon="fa-filter" title="Selecione as opções de pesquisa.">
                <b-card><!-- FILTROS -->
                    <b-form id="formFiltro">
                        <b-form-row>
                            <div class="col-md-12">
                                <SelectMarcas v-model="model.marcas" />
                                <b-form-row class="mb-2">
                                    <div class="col-lg-4">
                                        <b-form-group id="modelodreValores" label="Modelo de DRE:" label-for="modeloDREValoresSelect" class="position-relative">
                                            <custom-select-single v-model="model.ModeloDRE" :opt="listaModelo" />
                                        </b-form-group>
                                        <message-validation :showError="showValidation == true && model.ModeloDRE == ''">Campo obrigatório</message-validation>
                                    </div>
                                    <div class="col-lg-4">
                                        <b-form-group id="linhaValores" label="Linha da DRE:" label-for="linhaValoresSelect">
                                            <select2 required 
                                                :options="listas.linhaDRE" 
                                                name="linhaValoresSelect" 
                                                v-model="model.LinhaDRE"
                                                :refresh="true">
                                            </select2>
                                        </b-form-group>
                                        <message-validation :showError="showValidation == true && model.LinhaDRE == ''">Campo obrigatório</message-validation>
                                    </div>
                                    <div class="col-lg-4">
                                        <b-form-group id="competenciaValores" label="Competência:" label-for="competenciaValoresMes">
                                            <el-date-picker
                                                style="width:100%;"
                                                v-model="model.Competencia"
                                                type="month"
                                                placeholder="00/0000"
                                                format="MM/yyyy"
                                                size="small">
                                            </el-date-picker>
                                        </b-form-group>
                                        <message-validation :showError="showValidation == true && isNullOrEmpty(model.Competencia)">Campo obrigatório</message-validation>
                                    </div>
                                </b-form-row>
                                <b-form-row class="mb-2">
                                    <div class="col-lg-6">
                                        <b-form-group id="grupoValores" label="Grupo:" label-for="grupoValoresSelect">
                                            <select2
                                              :options="listas.grupos" 
                                              name="grupoValoresSelect" 
                                              v-model="model.Grupos" 
                                              :url="$urls.GRUPOS">
                                            </select2>
                                        </b-form-group>
                                        <message-validation :showError="showValidation == true && isNullOrEmpty(model.Grupos)">Campo obrigatório</message-validation>
                                    </div>
                                    <div class="col-lg-6">
                                        <b-form-group id="empresasValores" label="Empresas:" label-for="empresasValoresASelect">
                                            <custom-select-multiple 
                                              v-if="isRerender" 
                                              v-model="model.Empresas"
                                              group
                                              :url="`${$urls.EMPRESAS}?marcas=${model.marcas.join(',')}`"
                                            />
                                        </b-form-group>
                                    </div>
                                </b-form-row>
                            </div>
                        </b-form-row>
                    </b-form>
                    <!-- BOTÕES DE AÇÕES -->
                    <div slot="footer">
                        <div class="float-left">
                            <button-validation v-if="temAcesso('DreValorManual','Obter')" @click.native="pesquisarValoresManuais" variant="primary" :disabled="pesquisarDisabled">
                                Pesquisar
                            </button-validation>
                            <button-validation v-else disabled v-b-tooltip.hover title="Sem permissões" class="no-drop">
                                Pesquisar
                            </button-validation>
                            <b-button style="width:100px;" v-if="temAcesso('DreValorManual','Obter')" @click.prevent="limparValoresManuais" size="sm" class="mr-2">Limpar</b-button>
                        </div>
                        <div class="float-right">
                            <b-dropdown id="exportar_dropdown" right dropup size="sm" text="Exportar" variant="info">
                                <b-dropdown-item v-if="temAcesso('DreValorManual','Exportar')" @click="exportarValoresManuais"><b>Exportar</b> modelo</b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>

                </b-card>
            </container-card>
            <!-- TABELA DE VALORES MANUAIS -->
            <div :class="showListValoresManuais ? 'd-block' : 'd-none'" v-loading="loadingListValores">
                <container-card fixed id="valoresDRE" icon="fa-th-list" title="Valores pesquisados.">
                    <b-card>
                        <el-table
                            ref="ValoresManuaisTable"
                            :data="tableValoresManuais"
                            highlight-current-row
                            style="width: 100%"
                            size="mini">

                                <el-table-column
                                    type="index"
                                    width="50">
                                </el-table-column>
                                <el-table-column
                                    property="clienteNome"
                                    label="Grupo"
                                    width="200">
                                </el-table-column>
                                <el-table-column
                                    property="empresaNome"
                                    label="Empresa (CNPJ/Código)"
                                    width="200">
                                </el-table-column>
                                <el-table-column
                                    label="Valor"
                                    width="150"
                                    >
                                    <!-- CONFIGURAÇÕES DO INPUT DE VALOR MANUAL/EDITAR -->
                                    <template slot-scope="scope" v-if="scope.row">
                                        <money 
                                            v-if="temAcesso('DreValorManual','Editar')"
                                            :ref="`valorManualEdit_${scope.$index}`"
                                            :disabled="scope.row.request" 
                                            v-model="scope.row.valor" 
                                            v-bind="money" 
                                            class="input-valor-manual"
                                            @blur.native="handleEditCell(scope.$index, scope.row)">
                                        </money>
                                        <money 
                                            v-else
                                            :ref="`valorManualEdit_${scope.$index}`"
                                            disabled
                                            v-model="scope.row.valor" 
                                            v-bind="money" 
                                            class="input-valor-manual no-drop"
                                            v-b-tooltip.hover title="Sem permissões">
                                        </money>
                                        <div v-if="scope.row.request == false" class="edit-valor-lapis"><!-- icone de editar/lapis -->
                                            <i class="fas fa-pen"></i>
                                        </div>
                                        <div v-if="scope.row.request" class="load-edit-valor"><!-- icon de load no request -->
                                            <i v-show="scope.row.request == true" style="font-size: 15px;" class="fas fa-spinner fa-pulse"></i>
                                        </div>
                                        <div class="success-edit-valor" v-show="scope.row.success == true"><!-- label ao atualizar valor -->
                                            <i class="fa fa-check" aria-hidden="true"></i>
                                            &nbsp;&nbsp;
                                            Valor atualizado
                                        </div>
                                    </template>

                                </el-table-column>

                        </el-table>
                    </b-card>
                </container-card>
            </div>

            <!-- Response de importar arquivo -->
            <b-modal ref="responseUploadModal" title="Existem alguns erros em seu arquivo" size="md" ok-only v-drag>
                <b-row class="text-center">
                    <b-col>
                        <strong>Total Registros: </strong>{{ upload.totalRegistros }}
                    </b-col>
                    <b-col>
                        <strong>Registros inseridos: </strong>{{ upload.totalInseridos }}
                    </b-col>
                </b-row>
                <div class="d-block text-center" style="max-height:400px">
                    <br><strong>Total avisos: </strong> {{ upload.totalNotas }}
                    <b-list-group style="max-height: 200px !important; overflow: auto;">
                        <b-list-group-item v-for="(item, index) in upload.notas" :key="index" class="list-group-import d-flex justify-content-between align-items-center">
                            <b-badge variant="primary" pill>{{ index }}</b-badge>
                            {{ item }}
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </b-modal>
        </div>
    </b-row>
</template>
<script>
import ContainerCard from '@/components/shared/ContainerCard'
import Select2 from '@/components/shared/Select2'
import MessageValidation from '@/components/shared/MessageValidation'
import ButtonValidation from '@/components/shared/ButtonValidation'
import SelectMarcas from '@/components/shared/SelectMarcas'

const listas = () => {
    return {
        modelosDRE: [],
        linhaDRE: [],
        empresas: [],
        grupos: [],
        importarOptions: [
            { text: 'Preservar valores cadastrados no sistema.', value: 1 },
            { text: 'Sobrescrever valores cadastrados no sistema.', value: 2 }
        ],
    }
}
const model = () => {
    return {
        ModeloDRE: '',
        LinhaDRE: '',
        Competencia: '',
        Empresas: [],
        Grupos: '',
        marcas: []
    }
}
const modelImportar = () => {
    return {
        ModeloDREImportar: '',
        opcaoValores: 1
    }
}

export default {
    name: 'dre',
    props: ['modeloId','listaModelo'],
    components: {
        MessageValidation,
        'button-validation': ButtonValidation,
        'container-card': ContainerCard,
        'select2': Select2,
        SelectMarcas
    },
    data(){
        return {
            showValidation: false,
            showValidationUpload: false,
            mensagemErro: {},
            showListValoresManuais: false,
            pesquisarDisabled: false,
            exportarDisabled: false,
            loadingListValores: false,
            isRerender: true,
            listas: listas(),
            model: model(),
            modelImportar: modelImportar(),
            tableValoresManuais: [],
            fileList: [],
            upload: {
                notas: [],
                totalRegistros:0,
                totalInseridos:0,
                totalNotas:0
            }
        }
    },
    methods: {
        isValidDRE(){
            const self = this

            if(this.model.ModeloDRE == '' || self.model.LinhaDRE == '' || self.model.Grupos == '' || (self.isNullOrEmpty(self.model.Competencia))){
                self.showValidation = true
                return false
            }

            return true
        },
        paramsPesquisaDRE(){
            const self = this

            return {
                DreId: self.model.ModeloDRE,
                LinhaDaDreId: self.model.LinhaDRE,
                Competencia: this.moment(self.model.Competencia).format('YYYY-MM-DD'),
                Empresas: self.model.Empresas.join(','),
                Grupo: self.model.Grupos,
                UsarCentroDeCustoPadrao: true,
                marcas: self.model.marcas.join(',')
            }
        },
        pesquisarValoresManuais(){
            const self = this

            if (!self.isValidDRE()) return

            self.pesquisarDisabled = true
            self.loadingListValores = true
            self.showListValoresManuais = true

            this.trackingF360(this, 'DRE Valores Manuais', 'Pesquisar');

            self.axios.get(this.$urls.DRE_LISTA_VALORES_MANUAIS, { params: self.paramsPesquisaDRE() }).then((res) => {
                if(res.data.length <= 0){
                    self.mensagemErro = { erro: false, msg: "Nada encontrado !" }
                    return false
                }
                
                // add enabled e request para a edição do valor manual(table)
                self.tableValoresManuais = res.data.valores.map((val) => {
                    val.request = false
                    val.success = false
                    return val
                })

                self.showValidation = false
                self.pesquisarDisabled = false
                self.loadingListValores = false
            }).catch(function () {
                self.tableValoresManuais = []
                self.showValidation = false
                self.pesquisarDisabled = false
                self.loadingListValores = false
                self.mensagemErro = { erro: true, msg: "Ocorreu algum problema com a requisição !" }
            })
        },
        limparValoresManuais(){
            this.showValidation = false
            this.$data.model = model()
        },
        exportarValoresManuais(){
            const self = this

            this.exportarDisabled = true

            this.trackingF360(this, 'DRE Valores Manuais', 'Exportar');
            
            //deixamos em 2 etapas, mas futuramente podemos juntar em uma etapa só
            self.$blob.postDownload(`${this.$urls.DRE_EXPORTAR_PLANILHA_MODELO_VALORES_MANUAIS}`, self.model,() => {
                self.showValidation = false
                self.exportarDisabled = false
            })
        },
        handleEditCell(index, row){ // Editar valor manual
            var self = this
            
            row.competencia = self.moment(self.model.Competencia).format('YYYY-MM-DD')
            row.request = true

            const { ...dataSend } = row; // removo request e success do objeto e add em 'dataSend' para enviar o data limpo

            self.axios.post(self.$urls.DRE_ATUALIZAR_VALORES_MANUAIS,dataSend).then((dt) => {
                row._id = dt.data._id
                
                row.request = false
                row.success = true
                setTimeout(() => {
                    row.success = false // efeito da label "Valor atualizado"
                },1000)
            }).catch(() => {
                row.request = false
                row.success = false
            })
        },
        toogleBtns(e){
            console.log('event: ',e)
        }
    },
    watch: {
         model: {
            handler: function(){
                this.showListValoresManuais = false
            },
            deep: true
        },
        modeloId(val){
            this.model.ModeloDRE = val
        },
        'model.ModeloDRE': function(val){
            var self = this
            self.axios.get(`${self.$urls.DRE_LINHAS_VALORES_MANUAIS}?modeloDre=${val}`).then((dt) => {
                if(!dt){ 
                    self.listas.linhaDRE = []
                    return false 
                }
                self.listas.linhaDRE = dt.data
            })
        },
        'model.marcas'() { // sempre que marcas for alterado, redesenha o select de empresas
            this.isRerender = false;
            this.$nextTick(()=>{ 
                this.listas.empresas = []
                this.isRerender = true;
            });
        }
    },
    mounted() {
        //this.model.ModeloDRE = this.modeloId
    }
}
</script>
<style>
    .el-picker-panel {  z-index: 999999 !important; } /* zindex alto para ficar acima de todos os components */
    .upload-valores{ width:100%; }
    .el-upload-list__item i.el-icon-close{ display:none !important; }
    input.v-money {
        border-radius: 3px;
        border: 1px solid #c5c1c1;
        text-align: right;
        padding-right: 5px;
        width: 100%;
    }
    .list-group-import {
        font-size: 12px;
        transition: 0.3s;
    }
    .list-group-import:hover{
        background: #feffc9;
    }
    .list-group-import .badge {
        font-size: 10px;
        height: 18px;
        position: relative;
        left: -11px;
    }
    .div-mask-cell {
        width: 90%;
        height: 100%;
        position: absolute;
        top: 0;
        background: transparent;
        cursor:pointer;
    }
    .load-edit-valor, .edit-valor-lapis {
        position: absolute;
        top: 9px;
        left: 14px;
    }
    .edit-valor-lapis {
        font-size:13px;
        width:10px;
        height:10px;
        cursor: text;
        top: 7px;
    }
    .success-edit-valor {
        position: absolute;
        top: 9px;
        right: -110px;
        color: #01960d;
    }
    .input-valor-manual {
        background: #c5c1c1;
    }
    .input-valor-manual:focus {
        background: #fff;
    }
</style>
